import { render, staticRenderFns } from "./CookiesPolicy.vue?vue&type=template&id=5799cd3f&scoped=true&"
import script from "./CookiesPolicy.vue?vue&type=script&lang=js&"
export * from "./CookiesPolicy.vue?vue&type=script&lang=js&"
import style0 from "./CookiesPolicy.vue?vue&type=style&index=0&id=5799cd3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5799cd3f",
  null
  
)

export default component.exports